import "./ts/navigation";
import "./ts/menu";
import "./ts/scroller";
import "./ts/slider";
import "./ts/accordion";
import MatchHeight from '@tannerhodges/match-height';
import simpleParallax from 'simple-parallax-js';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });

import './main.css';

var image = document.getElementsByClassName('parax');
new simpleParallax(image, {
  scale: 1.1,
  delay: .5,
  transition: 'cubic-bezier(0,0,0,1)',
  orientation: 'down',
});

MatchHeight.add('.service__text p, .project__desc h2, .info__card');

